<template></template>

<script setup lang="ts">
  import { FilterMatchMode } from "primevue/api";
  import { defineColumnFilter, defineColumnProps } from "../../lib/defines";

  defineExpose(
    Object.assign(
      {},
      defineColumnProps({
        sortable: true,
        showFilterOperator: false,
        showFilterMatchModes: true,
        showApplyButton: false,
        showClearButton: false,
      }),
      defineColumnFilter({
        matchMode: FilterMatchMode.CONTAINS,
      }),
    ),
  );
</script>
